export default "__VITE_ASSET__8e806ca5__"